import classNames from 'classnames';
import React, { useState } from 'react';
import EfImgVideo from '../ef-img-video';
import EfLink from '../ef-link';
import EfButton from '../ef-button';

import gtm from '@/utils/gtm';
import './index.scss';

export interface EfTabBannerItemProps {
    /**
     * tab名称
     */
    tabName: string;

    /**
     * 资源链接是否是视频
     */
    isVideo?: boolean;

    /**
     * 所有分辨率展示的资源链接
     */
    pc: string;

    /**
     * 分辨率小于等于1024px展示的资源链接
     */
    h5?: string;

    /**
     * 视频贴图-所有分辨率
     */
    poster?: string;

    /**
     * 视频贴图-分辨率小于等于1024px
     */
    posterH5?: string;

    /**
     * 更多文案
     */
    moreText?: string;

    /**
     * 更多链接
     */
    moreHref?: string;

    /**
     * 更多文案
     */
    buyText?: string;

    /**
     * 更多链接
     */
    buyHref?: string;

    /**
     * 顶部 tip/tag
     */
    label?: string;

    /**
     * 标题
     */
    title?: string;

    /**
     * 子标题
     */
    subTitle?: string;

    /**
     * 描述
     */
    desc?: string;
}
interface EfTabBannerProps {
    /**
     * 主题色
     */
    theme?: 'white' | 'black';
    /**
     * 样式名
     */
    className?: string;
    /**
     * 列表
     */
    list: EfTabBannerItemProps[];
    /**
     * 埋点数据-list_name
     */
    gtm_list_name?: string;
}

/**
 * 维护:杨柏迪
 *
 * tab 切换banner
 */
const EfTabBanner: React.FC<EfTabBannerProps> = ({ theme = 'white', className, list, gtm_list_name = 'none' }) => {
    const prefixCls = `ef-tab-banner`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-${theme}`]: theme,
    });
    const [activeIndex, setActiveIndex] = useState(0); //选中下标
    const [activeItem, setActiveItem] = useState(list[0] || {}); //选中元素

    // 点击切换tab
    const toggleItemHandle = (item: EfTabBannerItemProps, index: number) => {
        setActiveIndex(index);
        setActiveItem(item);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: 'none',
            button_name: item.tabName,
        });
    };

    // 埋点--更多
    const more_gtm = [
        {
            event: 'uaEvent',
            event_name: 'select_product',
            list_name: gtm_list_name,
            product_name: activeItem?.title,
            button_name: activeItem?.moreText,
        },
    ];

    // 埋点--buy
    const buy_gtm = [
        {
            event: 'uaEvent',
            event_name: 'buy',
            product_name: activeItem?.title,
            position: gtm_list_name,
        },
    ];

    return (
        <div className={classes}>
            <div className={`${prefixCls}-wrapper`}>
                <div className={`${prefixCls}-bg`}>
                    <EfImgVideo pc={activeItem?.pc} h5={activeItem?.h5 || activeItem?.pc} />
                </div>
                <div className={`${prefixCls}-content`}>
                    {!!activeItem?.label && <p className={`${prefixCls}-label`}>{activeItem?.label}</p>}
                    {!!activeItem?.title && <p className={`${prefixCls}-title`}>{activeItem?.title}</p>}
                    {!!activeItem?.subTitle && <p className={`${prefixCls}-sub-title`}>{activeItem?.subTitle}</p>}
                    {!!activeItem?.desc && <p className={`${prefixCls}-desc`}>{activeItem?.desc}</p>}
                    <div className={`${prefixCls}-btns`}>
                        {activeItem?.moreHref && activeItem?.moreText && (
                            <EfButton href={activeItem?.moreHref} type="link_more" theme={theme} dataLayer={more_gtm}>
                                {activeItem?.moreText}
                            </EfButton>
                        )}
                        {activeItem?.buyHref && activeItem?.buyText && (
                            <EfButton href={activeItem?.buyHref} type="buy_now" theme={theme} dataLayer={buy_gtm}>
                                {activeItem?.buyText}
                            </EfButton>
                        )}
                    </div>
                </div>

                <div className={`${prefixCls}-tabs`}>
                    {list.map((item, index) => (
                        <p
                            key={index}
                            className={`${prefixCls}-tab-item ${activeIndex === index ? `${prefixCls}-tab-item-active` : ''}`}
                            onClick={() => toggleItemHandle(item, index)}
                        >
                            {item?.tabName}
                        </p>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default EfTabBanner;
